if (!customElements.get('geek-product-share')) {
  customElements.define('geek-product-share', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const status = this.querySelector('[role="status"]');
      const copy = this.querySelector('[data-copy]');
      const native = this.querySelector('[data-native]');
      const fallback = this.querySelector('.go-share__fallback');
      const url = this.dataset.url;
      copy.hidden = false;
      native.hidden = typeof navigator.share !== 'function';
      copy.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(url);
          status.textContent = 'Link copied. Make someone’s day.';
          fallback.hidden = true;
        } catch (_) {
          fallback.hidden = false;
          const input = fallback.querySelector('input');
          input.focus();
          input.select();
          status.textContent = 'Select and copy the link below.';
        }
      });
      native.addEventListener('click', async () => {
        status.textContent = '';
        try {
          await navigator.share({title: this.dataset.title, url});
        } catch (error) {
          if (error.name !== 'AbortError') status.textContent = 'Try WhatsApp or Copy link instead.';
        }
      });
    }
  });
}
